// shared helpers for deriving display values from a user like object.
// nulls allowed so it works with session users, db docs and
// form state alike. callers add their own fallback when they need one

export type NamedUser = {
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
};

// "First Last" when both parts exist, otherwise whichever single part exists,
// otherwise undefined
export function getFullName(user?: NamedUser | null): string | undefined {
  const firstname = user?.firstname;
  const lastname = user?.lastname;
  if (firstname && lastname) return `${firstname} ${lastname}`;
  return firstname || lastname || undefined;
}

// uppercase initials, e.g. "FL". empty string when no name parts exist
export function getInitials(user?: NamedUser | null): string {
  const first = user?.firstname?.[0] ?? '';
  const last = user?.lastname?.[0] ?? '';
  return `${first}${last}`.toUpperCase();
}

// { name, email } stamp used for createdBy / updatedBy audit fields
export function getUserInfo(user?: NamedUser | null): {
  name?: string;
  email?: string;
} {
  return {
    name: getFullName(user),
    email: user?.email ? String(user.email) : undefined,
  };
}
